/* eslint-disable no-new */
import Vue from 'vue';
import Vuebar from 'vuebar';
import App from './App.vue';
import router from './router';
import store from './store';
import mixin from './mixin';
import filters from './filters';
import plugins from './plugins';
import oax from './utils/oax';

Vue.mixin(mixin);
Vue.use(Vuebar);
Vue.config.productionTip = false;

filters(Vue);
plugins(Vue);

oax.get('/api/authentication').then(({ data }) => {
  store.commit('setAuthentication', data.authentication);
  store.commit('setPersonalInfo', data.personalInfo);
  store.commit('setShort', data.short);
  const org = location.pathname.replace(/\/(kcl|ktc|ktr|kilt|fiti)?.*/i, '$1');
  if (org) store.commit('setSite', org);
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
  });
});




// WEBPACK FOOTER //
// ./src/main.js